import { defineBoot } from '@quasar/app-vite/wrappers';
import _get from 'lodash/get';

/**
 * Adds Lodash's "get" method for use in templates.
 *
 * @param {{ app: import('vue').App }} params
 */
export default defineBoot(({ app }) => {
  app.config.globalProperties.$_get = _get;
});
